export class RatingProgramMap {
  rating: number;
  program: number;

  constructor(rating: number, program: number) {
    this.rating = rating;
    this.program = program;
  }
}
